import { createSlice } from '@reduxjs/toolkit'

export const canvasSlice = createSlice({
  name: 'canvas',
  initialState: {
    selected: [],
    directSelected: null,
    directSelectPreview: null,
    rectSelectRegion: {},
    //item properties updated
    itemUpdated: {},
    //scale range or domain updated
    scaleUpdated: {},
    axisHandleVisible: false,
    legendClicked: {},
    dataItemJoined: {},
    newItemCreated: {},
    itemsDeleted: [],
    undoStackChanged: {"length" : 0},
    redoStackChanged: {"length" : 0},
    zoomLevel: 100,
    panDelta: {"x": 0, "y": 0}
  },
  reducers: {
    select: (state, action) => {
      state.selected = action.payload;
    },
    directSelect: (state, action) => {
      state.directSelected = action.payload;
    },
    directSelectPreview: (state, action) => {
      state.directSelectPreview = action.payload;
    },
    rectSelect: (state, action) => {
      state.rectSelectRegion = action.payload;
    },
    draw: (state, action) => {
      console.log(action);
    },
    updateItem: (state, action) => {
      state.itemUpdated = action.payload;
    },
    updateScale: (state, action) => {
      state.scaleUpdated = action.payload;
    },
    toggleAxisHandle: (state, action) => {
      state.axisHandleVisible = action.payload;
    },
    customizeColorPalette: (state, action) => {
      state.legendClicked = action.payload;
    },
    joinDataItem: (state, action) => {
      state.dataItemJoined = action.payload;
    },
    createNewItem: (state, action) => {
      state.newItemCreated = action.payload;
    },
    deleteItems: (state, action) => {
      state.itemsDeleted = action.payload;
    },
    updateUndoStack: (state, action) => {
      state.undoStackChanged = action.payload;
    },
    updateRedoStack: (state, action) => {
      state.redoStackChanged = action.payload;
    },
    setZoomLevel: (state, action) => {
      state.zoomLevel = action.payload;
    },
    pan: (state, action) => {
      state.panDelta = action.payload;
    }
  }
})

// Action creators are generated for each case reducer function
export const { select, directSelect, directSelectPreview, rectSelect, draw, updateItem, updateScale, toggleAxisHandle, customizeColorPalette, joinDataItem, createNewItem, deleteItems, updateUndoStack, updateRedoStack, setZoomLevel, pan } = canvasSlice.actions;

export default canvasSlice.reducer;